import { gridReducer, createInitialGrid } from '../grid/gridReducer'
import { loadGrid, saveGrid } from '../grid/gridStorage'

export const GUIDES_GRID_KEY = 'ct-grid-guides-v1'
const LIMITS = { maxWindows: 6, maxPerColumn: 2, maxColumns: 3 }

// Open a guide in the Guides grid, then the caller navigates to /guides.
// Same idea as openItemInCode: the page is unmounted here, so the grid is
// written before the route change.
export function openGuideInGuides(guideId) {
  if (!guideId || typeof window === 'undefined') return null
  let state = loadGrid(GUIDES_GRID_KEY)
  const count = state.columns.reduce((n, col) => n + col.windows.length, 0)
  if (!count) state = createInitialGrid('guide')
  state = gridReducer(state, {
    type: 'SELECT_ENTITY',
    entityType: 'guide',
    entityId: guideId,
    limits: LIMITS,
  })
  saveGrid(GUIDES_GRID_KEY, state)
  return guideId
}
